import { render, staticRenderFns } from "./tgAction.vue?vue&type=template&id=a1984ffa&scoped=true"
import script from "./tgAction.vue?vue&type=script&lang=js"
export * from "./tgAction.vue?vue&type=script&lang=js"
import style0 from "./tgAction.vue?vue&type=style&index=0&id=a1984ffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1984ffa",
  null
  
)

export default component.exports